export const iconFontAwesomeWeatherSnowflake = (
	<i className="fa-solid fa-snowflake"></i>
);
